import { render } from "./CreateInternship.vue?vue&type=template&id=62132c56&scoped=true&ts=true"
import script from "./CreateInternship.vue?vue&type=script&lang=ts"
export * from "./CreateInternship.vue?vue&type=script&lang=ts"

import "./CreateInternship.vue?vue&type=style&index=0&id=62132c56&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62132c56"]])

export default __exports__